import * as React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { throttle } from 'throttle-debounce';

import { trackBubbleButtonClick } from './tracking';
import { sendWsAnswer } from '../../actions/wsAnswer';
import { Promo, Socket } from '../../components/ActionButton';
import { currentOpenChatIDSelector } from '../../selectors';
import { TBubbleActionButton } from '../../types/messageBubble';
import { DemandActionContainer } from '../DemandActionContainer';

type TBubbleButtonContainerProps = {
  messageId: string;
  button: TBubbleActionButton;
  analyticsBubbleType: string;
};

const DEMAND_TRAP_LINK = 'homeownerLeadCreateMessage';

const THROTTLE_DELAY = 3000;

export const BubbleButtonContainer: React.FC<TBubbleButtonContainerProps> = ({
  button,
  messageId,
  analyticsBubbleType,
}) => {
  const { link, type, text, socketPayload, analyticsButtonName } = button;

  const dispatch = useDispatch();

  const chatId = useSelector(currentOpenChatIDSelector) as string;

  const handleDeeplinkClick = React.useCallback(() => {
    trackBubbleButtonClick(chatId, analyticsBubbleType, analyticsButtonName);
  }, [analyticsBubbleType, analyticsButtonName, chatId]);

  const throttledSocketClick = React.useCallback(
    throttle(
      THROTTLE_DELAY,
      () => {
        dispatch(sendWsAnswer({ messageId, payload: socketPayload as string }));
        trackBubbleButtonClick(chatId, analyticsBubbleType, analyticsButtonName);
      },
      { noTrailing: true },
    ),
    [analyticsBubbleType, analyticsButtonName, chatId, dispatch, messageId, socketPayload],
  );

  if (link === DEMAND_TRAP_LINK) {
    return <DemandActionContainer actionButton={button} />;
  }

  if (type === 'socket') {
    return <Socket text={text} onClick={throttledSocketClick} />;
  }

  if (type === 'deeplink' && link) {
    return <Promo link={link as string} text={text} onClick={handleDeeplinkClick} />;
  }

  return null;
};
